import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import ConfirmModal from "./ConfirmModal";
import { NoticeRequest, subscribeNotice } from "../utils/notice";

// notify() / askConfirm() の表示先。画面に1つだけ置く（BusinessCards.tsx）
// 続けて呼ばれたときは順番に1つずつ出す
// カメラは全画面表示（Fullscreen API）を使うので、全画面中はその要素の中に出す（外に出すと全画面の裏に隠れる）
const GlobalNoticeModal: React.FC = () => {
  const [queue, setQueue] = useState<NoticeRequest[]>([]);
  const [container, setContainer] = useState<Element>(() => document.fullscreenElement ?? document.body);

  useEffect(() => subscribeNotice((request) => setQueue((prev) => [...prev, request])), []);

  useEffect(() => {
    const handleChange = () => setContainer(document.fullscreenElement ?? document.body);
    document.addEventListener("fullscreenchange", handleChange);
    return () => document.removeEventListener("fullscreenchange", handleChange);
  }, []);

  const current = queue[0];
  const close = (ok: boolean) => {
    current?.resolve(ok);
    setQueue((prev) => prev.slice(1));
  };

  return createPortal(
    <ConfirmModal
      key={container === document.body ? "body" : "fullscreen"}
      open={Boolean(current)}
      title={current?.title ?? ""}
      message={<p className="whitespace-pre-line">{current?.message}</p>}
      confirmLabel={current?.confirmLabel ?? "閉じる"}
      danger={current?.danger}
      hideCancel={current?.kind === "notice"}
      onConfirm={() => close(true)}
      onCancel={() => close(false)}
    />,
    container
  );
};

export default GlobalNoticeModal;
